import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import './styles.css';

const Submit = ({ onClick, count, label, disabled }) => {
	return (
		<div className={`submit ${disabled?'disabled':''}`} onClick={!disabled?onClick:() => {}}>
			<Icon icon={'submission'} />
			<span>
				{label} ({count} /3)
			</span>
		</div>
	);
};

Submit.propTypes = {
	count: PropTypes.number
};

export default Submit;
